import { render, staticRenderFns } from "./PermissionsAddNew.vue?vue&type=template&id=8092c990&"
import script from "./PermissionsAddNew.vue?vue&type=script&lang=js&"
export * from "./PermissionsAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsAddNew.vue?vue&type=style&index=0&id=8092c990&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports